import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Router from 'admin/routes/router';
import Modal from 'common/components/modules/modal';
import Button from 'common/components/elements/buttons/primary';
import { generateUriSegment } from 'common/utils/mediaRouteHelper';
// import { getProtocol } from 'common/utils/utils.js';


import './style.scss'
import DateFormatter from 'common/utils/DateFormatter';
import Intercom from 'common/utils/Intercom';
import { ARTICLE_ID_ON_REPOST } from 'common/utils/intercom-articles';

const OptionsModal = ({
   isMobile,
   closeModal,
   openClickDelete,
   id,
   title,
   onClickEdit,
   isLink,
   editText,
   deleteText,
   deleteButtonDisabled,
   animate,
   onShare,
   pinning,
   is_pinned,
   hidePinAction,
   isDemoMode,
   isPublished,
   availableRepostDate,
   onClickOpenRepostModal,
   showRepostButton,
}) => {
   let calculateTimeLeft = () => DateFormatter.calculateTimeLeft(availableRepostDate)
   const [timeLeft, setTimeLeft] = useState(availableRepostDate ? calculateTimeLeft() : null)

   function closeOnClickOutside(e) {
      if(!isMobile && !e.target.closest(`.store-${ id }`)) {
         closeModal()
      }
   }
   useEffect(() => {
      window.addEventListener('click', closeOnClickOutside, true);
      return () => {
         window.removeEventListener('click', closeOnClickOutside, true);
      };
   // eslint-disable-next-line
   }, [closeModal, isMobile]);


   useEffect(() => {
      let timer
      if(timeLeft !== null) {
         timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
         }, 1000);
      }

      return () => clearInterval(timer);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [timeLeft]);

   const editButton = (
      <Button
         text={ editText }
         fontWeight='normal'
         textSize='small'
         textColor='major'
         classNames='h-full w-full'
         iconName='pencil'
         fontIconColor='secondary'
         iconPosition='left'
         fontIconSize='extraLarge'
         alignment='end'
         padding='none'
         backgroundColor='transparent'
         onClick={ onClickEdit }
      />
   )
   const view = (
      <div
         className={ `shadow dark:shadow-dark store-${ id } flex flex-col w-full bg-panel py-1 items-center store-list-options
          justify-between select-none ${ isMobile ? '' : 'border border-divider rounded-lg' }` }>
         <div
            className='flex w-full  text-xs h-10 items-center justify-between px-4 hover:bg-hover cursor-pointer'>
            {
               isLink && (
                  <Link
                     to={ Router.route('STORE_DETAILS').getCompiledPath({ id: generateUriSegment(id, title) }) }
                     onClick={ (e) => {
                        e.stopPropagation()
                     } }
                  >
                     {editButton}
                  </Link>
               )
            }
            {
               !isLink && (
                  editButton
               )
            }
         </div>
         {
            !hidePinAction &&
            <div className={ `h-10 w-full px-4 hover:bg-hover ${ !is_pinned ? 'intercom-pin-content' : '' }` }>
               <Button
                  text={ !is_pinned ? 'Pin' : 'Unpin' }
                  textSize='small'
                  textColor='major'
                  classNames='h-full w-full'
                  iconName={ !is_pinned ? 'pin' : 'unpin' }
                  fontIconColor='secondary'
                  iconPosition='left'
                  alignment='end'
                  padding='none'
                  backgroundColor='transparent'
                  fontWeight='noraml'
                  fontIconSize='extraLarge'
                  onClick={ (e) => {
                     e.stopPropagation()
                     e.preventDefault()
                     pinning(id, is_pinned)
                     closeModal()
                  } }
               />
            </div>
         }
         {
            onShare &&
            <div className='flex w-full h-10 items-center justify-between px-4 hover:bg-hover '>
               <Button
                  text='Share'
                  textSize='small'
                  textColor='major'
                  classNames='h-full w-full'
                  iconName='share'
                  fontWeight='noraml'
                  fontIconColor='secondary'
                  iconPosition='left'
                  alignment='end'
                  padding='none'
                  backgroundColor='transparent'
                  fontIconSize='extraLarge'
                  onClick={ (e) => {
                     e.stopPropagation()
                     e.preventDefault()
                     onShare(id, 'store')
                  } }
               />
            </div>
         }
         <div
            className={ `flex w-full h-10 items-center justify-between px-4 hover:bg-hover ${ deleteButtonDisabled ? 'opacity-50' : '' }` }
            data-tooltip-content={ deleteButtonDisabled ? 'Cannot remove category if associated with store items' : null }
            data-tooltip-id={ deleteButtonDisabled ? 'ams-top-tooltip' : null }
         >
            <Button
               text={ deleteText }
               onClick={ (e) =>  {
                  if(isDemoMode) return
                  e.stopPropagation()
                  e.preventDefault()
                  openClickDelete()
               } }
               iconName='delete'
               fontIconSize='extraLarge'
               fontWeight='noraml'
               iconPosition='left'
               classNames='h-full w-full'
               backgroundColor='transparent'
               fontIconColor='error'
               textColor='error'
               padding='none'
               alignment='end'
               textSize='small'
               disabled={ deleteButtonDisabled || isDemoMode }
               dataToolTipContent={ !!isDemoMode ? 'Not available in demo' : '' }
            />
         </div>
         {
            showRepostButton &&
            <div
               className={ `h-10 w-full px-4 hover:bg-hover flex items-center ${ !isPublished || !!timeLeft ? 'cursor-default' : '' }` }
               role='presentation'
               onClick={ (e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  if(!isPublished || !!timeLeft || isDemoMode) return
                  onClickOpenRepostModal(true, id)
               } }
            >
               <Button
                  text='Repost'
                  textSize='small'
                  textColor='major'
                  classNames='h-full !w-fit'
                  iconName='repost'
                  fontIconColor='secondary'
                  iconPosition='left'
                  alignment='end'
                  padding='none'
                  backgroundColor='transparent'
                  fontWeight='noraml'
                  fontIconSize='extraLarge'
                  dataToolTipContent={ isDemoMode ? 'Not available in demo' : (!isPublished ? 'You can repost only if the content status is Published' : timeLeft ? `You can repost this again in ${ timeLeft }` : null) }
                  disabled={ !isPublished || !!timeLeft || isDemoMode }
               />
               <Button
                  fontIconSize='base'
                  backgroundColor='transparent'
                  onClick={ (e) => {
                     e.stopPropagation()
                     e.preventDefault()
                     Intercom.showArticle(ARTICLE_ID_ON_REPOST)
                  } }
                  classNames='!w-fit !h-fit !ml-0.5'
                  iconName='help-outline'
                  fontIconColor='placeholder'
                  padding='none'
               />
            </div>
         }
      </div>
   )
   if(isMobile){
      return (
         <Modal
            onClose={ closeModal }
            roundedModal='lg'
            animate={ isMobile ? animate : null }
         >
            {view}
         </Modal>
      );
   } else {
      return (
         <div
            style={ {
               width: '200px',
               top: '28px',
               right: '-17px',
            } }
            className='absolute z-30 bottom-0'>
            {view}
         </div>
      )
   }

}


OptionsModal.propTypes = {
   isMobile: PropTypes.bool,
   closeModal: PropTypes.func,
   openClickDelete: PropTypes.func,
   onClickEdit: PropTypes.func,
   id: PropTypes.number,
   title: PropTypes.any,
   isLink: PropTypes.bool,
   editText: PropTypes.string,
   deleteText: PropTypes.string,
   deleteButtonDisabled: PropTypes.bool,
   animate: PropTypes.string,
   onShare: PropTypes.func,
   pinning: PropTypes.func,
   is_pinned: PropTypes.bool,
   hidePinAction: PropTypes.bool,
   isDemoMode: PropTypes.bool,
   isPublished: PropTypes.bool,
   onClickOpenRepostModal: PropTypes.func,
   availableRepostDate: PropTypes.string,
   showRepostButton: PropTypes.bool,
};
OptionsModal.defaultProps = {
   isLink: true,
   onClickEdit: () => {},
   editText: 'Edit',
   deleteText: 'Delete',
   deleteButtonDisabled: false,
   pinning: () => {},
   is_pinned: false,
   hidePinAction: false,
   isDemoMode: false,
   isPublished: false,
   onClickOpenRepostModal: () => {},
}

export default OptionsModal
